import React from "react";
import clsx from "clsx";
import { observer } from "mobx-react";

import { withStyles } from "@material-ui/core/styles";

import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

class RoomCardHeader extends React.Component {
    static styles() {
        return {
            Container: {
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "1rem",
            },

            Left: {
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center",
            },

            Right: {
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "center",
            },

            PriorityBox: {
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",

                width: "3rem",
                height: "3rem",
                marginRight: "1rem",
                backgroundColor: "#ECEDEF",
            },

            Priority: {
                fontFamily: "Open Sans",
                fontWeight: "600",
                fontSize: "1.25rem",
                color: "#0A0E34",
            },

            Name: {
                fontFamily: "Open Sans",
                fontWeight: "600",
                fontSize: "1.25rem",
                color: "#737F8C",
            },

            Status: {
                fontFamily: "Open Sans",
                fontSize: "1rem",
                color: "#0A0E34",
            },

            StatusDot: {
                width: "0.75rem",
                height: "0.75rem",
                marginRight: "0.25rem",
            },

            StatusUnknown: {
                backgroundColor: "#DCDCDC",
            },

            StatusStable: {
                backgroundColor: "#C2E791",
            },

            StatusMaturing: {
                backgroundColor: "#F7CD84",
            },

            StatusMature: {
                backgroundColor: "#E6A2AA",
            },

            StatusOpen: {
                backgroundColor: "#444444",
            },
        }
    }

    render() {
        const classes = this.props.classes;

        let status = "Unknown";
        if (this.props.status) {
            let first = this.props.status.charAt(0).toUpperCase();
            status = first + this.props.status.slice(1);
        }

        const colorClass = {
            "Unknown": classes.StatusUnknown,
            "Stable": classes.StatusStable,
            "Maturing": classes.StatusMaturing,
            "Mature": classes.StatusMature,
            "Open": classes.StatusOpen,
        }[status] || classes.StatusUnknown;

        return (
            <Box className={classes.Container}>
                <Box className={classes.Left}>
                    <Box className={classes.PriorityBox}>
                        <Typography className={classes.Priority}>
                            {"#" + this.props.priority}
                        </Typography>
                    </Box>
                    <Typography className={classes.Name}>
                        {this.props.name}
                    </Typography>
                </Box>
                <Box className={classes.Right}>
                    <Avatar
                        className={clsx(classes.StatusDot, colorClass)}
                        // eslint-disable-next-line react/no-children-prop
                        children={""}
                    />
                    <Typography className={classes.Status}>{status}</Typography>
                </Box>
            </Box>
        );
    }
}

export default withStyles(RoomCardHeader.styles)(observer(RoomCardHeader));